export default {
  independentMarketing: {
    common: {
      requestFailed: 'Żądanie interfejsu nie powiodło się',
      hintSelect: 'Wybierać',
      hintInput: 'Wchodzić',
      submit: 'Składać',
      cancel: 'Anulować',
      confirm: 'OK',
    },
    agreement: {
      title: 'Umowa rejestracyjna niezależnego dealera Autel',
      nextBtn: 'Dalej',
      getAgreementFailed: 'Nie udało się pobrać treści umowy.',
    },
    successPage: {
      title:
        'Informacje o Twoim zgłoszeniu zostały pomyślnie przesłane, a wyniki przeglądu zostaną przesłane na Twój adres e-mail w wysokości $1 w ciągu 15 dni roboczych. Aby uzyskać więcej informacji, sprawdź swoją skrzynkę odbiorczą.',
      subTitle: 'Wróć do strony głównej po $1 sekundzie.',
    },
    applyTitle: 'Aplikujesz, aby zostać niezależnym sprzedawcą Autel. Proszę dokładnie wypełnić poniższe informacje:',
    companyName: 'Nazwa firmy',
    companyTax: 'VAT ID',
    userCountry: 'Kraj',
    legalPerson: 'Radca prawny',
    contactEmail: 'Adres e-mail do kontaktu',
    contactEmailTips:
      'Ten adres e-mail będzie Twoim kontaktem w przypadku wiadomości e-mail z wynikami recenzji. Po zatwierdzeniu recenzji będzie ono również używane jako nazwa konta logowania w niezależnym systemie zarządzania dealerami.',
    corporateIdentity: 'Identyfikator radcy prawnego',
    uploadTips: 'JPG, JPEG, PNG, PDF (nie większy niż 20 MB)',
    businessLicense: 'Zezwolenie na prowadzenie działalności',
    emailErrorTips: 'Wprowadź prawidłowy adres e-mail.',
    uploadPic: 'Przesyłać zdjęcia',
    picMaxLimit: 'Maksymalny rozmiar obrazu to 20 MB. Wybierz ponownie.',
  },
};
